import _ from 'lodash';
import DefaultDialogController from 'utils/notifications/default-dialog-controller';

function remove(array, index) {
  array.splice(index, 1);
  return array;
}

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { phoneExtRegex, phoneMask, phoneLength, locales } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
    phoneExtRegex,
    phoneMask,
    phoneLength,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'appFactory', '$timeout', 'Notifications', 'gettextCatalog')
class EditContactController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.language = this.language || this.selectedLanguage || this.locale;
    this.categoryChanged = false;
    this.oldCategory = this.contact.fields[this.language].category;
    this.setDefaultTemporaryPhone();
    this.setDefaultTemporaryEmail();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  setDefaultTemporaryPhone() {
    this.temporaryPhone = {
      phone: '',
      ext: '',
    };
    this.temporaryPhoneAddClicked = false;
  }

  setDefaultTemporaryEmail() {
    this.temporaryEmail = {
      email: '',
    };
    this.temporaryEmailAddClicked = false;
  }

  onCategoryChange(newCategory) {
    this.categoryChanged = this.oldCategory !== newCategory;
  }

  addPhone() {
    if (this.temporaryPhone.phone === '') {
      return;
    }
    if (!_.isEmpty(this.temporaryPhoneForm.$error)) {
      this.temporaryPhoneAddClicked = true;
      return;
    }
    this.locales.forEach((locale) => {
      this.contact.fields[locale.code].phone = this.contact.fields[locale.code].phone.concat(this.temporaryPhone);
    });
    this.setDefaultTemporaryPhone();
  }

  removePhone(index) {
    this.locales.forEach((locale) => {
      this.contact.fields[locale.code].phone = remove(this.contact.fields[locale.code].phone, index);
    });
  }

  addEmail() {
    if (this.temporaryEmail.email === '') {
      return;
    }
    if (!_.isEmpty(this.temporaryEmailForm.$error)) {
      this.temporaryEmailAddClicked = true;
      return;
    }
    this.locales.forEach((locale) => {
      this.contact.fields[locale.code].email = this.contact.fields[locale.code].email.concat(this.temporaryEmail);
    });
    this.setDefaultTemporaryEmail();
  }

  removeEmail(index) {
    this.locales.forEach((locale) => {
      this.contact.fields[locale.code].email = remove(this.contact.fields[locale.code].email, index);
    });
  }

  submit() {
    this.temporaryPhoneAddClicked = true;
    this.temporaryEmailAddClicked = true;

    this.form.$setSubmitted();
    if (this.form.$valid) {
      if (this.verifyOtherLanguages()) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Enter other language before submitting.'));
        return;
      }
      this.cleanContactAndEmail();
      this.confirm({ contact: this.contact, categoryChanged: this.categoryChanged });
    }
  }

  cleanContactAndEmail() {
    this.locales.forEach((locale) => {
      this.contact.fields[locale.code].phone = this.contact.fields[locale.code].phone.filter(
        (phone) => phone.phone !== '' || phone.ext !== ''
      );

      this.contact.fields[locale.code].email = this.contact.fields[locale.code].email.filter((email) => email.email !== '');
    });
  }

  onLanguageSelect(locale) {
    this.language = locale;
  }

  verifyOtherLanguages() {
    let otherLanguageError = false;
    this.locales.forEach((locale) => {
      if (!_.get(this, `contact.fields[${locale.code}].category`) || !_.get(this, `contact.fields[${locale.code}].name`)) {
        otherLanguageError = true;
      }
    });
    return otherLanguageError;
  }
}

export default EditContactController;



// WEBPACK FOOTER //
// ./src/modules/contact/components/manage-contact/edit-contact-dialog/edit-contact-dialog-controller.js